<template>
  <div class="thank-page">

    <!-- BACKGROUND DECOR -->
    <div class="bg-shape one"></div>
    <div class="bg-shape two"></div>

    <!-- CARD -->
    <div class="thank-card">

      <!-- ICON -->
      <div class="icon-wrap">
        <span class="material-symbols-outlined success-icon">
          check_circle
        </span>
      </div>

      <!-- TITLE -->
      <h1>Thank You!</h1>

      <!-- MESSAGE -->
      <p>
        Your feedback has been successfully submitted.
        We appreciate your support 🙌
      </p>

      <!-- ACTIONS -->
      <div class="actions">

        <button class="primary-btn" @click="goHome">
          Go to Home
        </button>

        <!-- <button class="secondary-btn" @click="referAgain">
          Refer Another
        </button> -->

      </div>

    </div>

    <!-- FOOTER -->
    <div class="footer">
      <span>🔒 Secure & Private</span>
      <span>✔ Trusted by Users</span>
    </div>

  </div>
</template>

<script>
export default {
  name: "ThankYou",

  methods: {
    goHome() {
      this.$router.push("/");
    },
    referAgain() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>

/* PAGE */

.thank-page{
  min-height:100vh;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  background:linear-gradient(135deg,#f8fafc,#eef6ff);
  position:relative;
  overflow:hidden;
  font-family:'Inter',sans-serif;
  padding:20px;
}

/* BACKGROUND SHAPES */

.bg-shape{
  position:absolute;
  border-radius:50%;
  filter:blur(60px);
  opacity:0.4;
}

.bg-shape.one{
  width:300px;
  height:300px;
  background:#197fe6;
  top:-80px;
  left:-80px;
}

.bg-shape.two{
  width:260px;
  height:260px;
  background:#22c55e;
  bottom:-80px;
  right:-80px;
}


/* CARD */

.thank-card{
  width:100%;
  max-width:420px;
  background:white;
  border-radius:24px;
  padding:36px 28px;
  text-align:center;
  box-shadow:0 25px 60px rgba(0,0,0,0.08);
  border:1px solid #eef2f7;
  z-index:2;
  animation:fadeUp 0.5s ease;
}

/* ICON */

.icon-wrap{
  display:flex;
  justify-content:center;
  margin-bottom:12px;
}

.success-icon{
  font-size:56px;
  color:#22c55e;
  animation:pop 0.4s ease;
}

/* TEXT */

.thank-card h1{
  font-size:26px;
  font-weight:900;
  color:#0f172a;
}

.thank-card p{
  font-size:14px;
  color:#64748b;
  margin-top:8px;
  line-height:1.5;
}

/* BUTTONS */

.actions{
  margin-top:22px;
  display:flex;
  flex-direction:column;
  gap:10px;
}

.primary-btn{
  height:46px;
  border-radius:12px;
  background:#197fe6;
  color:white;
  font-weight:700;
  border:none;
  cursor:pointer;
  transition:0.2s;
}

.primary-btn:hover{
  transform:translateY(-1px);
  box-shadow:0 10px 20px rgba(25,127,230,0.3);
}

.secondary-btn{
  height:44px;
  border-radius:12px;
  background:#f1f5f9;
  color:#0f172a;
  font-weight:600;
  border:none;
  cursor:pointer;
  transition:0.2s;
}

.secondary-btn:hover{
  background:#e2e8f0;
}

/* FOOTER */

.footer{
  margin-top:18px;
  display:flex;
  gap:18px;
  font-size:11px;
  color:#94a3b8;
  z-index:2;
}

/* ANIMATIONS */

@keyframes fadeUp{
  from{
    transform:translateY(10px);
    opacity:0;
  }
  to{
    transform:translateY(0);
    opacity:1;
  }
}

@keyframes pop{
  from{
    transform:scale(0.8);
    opacity:0;
  }
  to{
    transform:scale(1);
    opacity:1;
  }
}

/* MOBILE */

@media (max-width:768px){

  .thank-card{
    padding:26px 20px;
    border-radius:18px;
  }

  .thank-card h1{
    font-size:22px;
  }

  .footer{
    flex-direction:column;
    gap:6px;
    text-align:center;
  }

}

</style>